/*
 * @Author: Teemo Ding
 * @Date: 2021-10-14 13:22:05
 * @LastEditTime: 2021-10-15 15:11:00
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelSelection/index.tsx
 */
import { Modal, ModalFooter } from '@/src/components/Antd';
import { cloneDeep } from 'lodash';
import React, { useMemo, useState } from 'react';

import { useSelector } from 'react-redux';
import { SizeFittingTable } from 'src/components/Antd';
import { getSalesChannels } from 'src/constrains/GlobalProvider/slice';
import _Query from 'src/constrains/Query1';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { columns } from './config';
import css from './css.module.less';

const SalesChannelSelection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { visible, onCancel, onOk, selectedItems } = props;
  const [searchCondition, setSearchCondition] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState(selectedItems || []);
  //   const [salesChannels, setSalesChannels] = React.useState<any[]>([]);
  const salesChannels = useSelector(getSalesChannels());
  const onOkPress = () => {
    onOk(selectedRowKeys);
  };

  const filterSalesChannel = useMemo(
    () =>
      salesChannels.filter((o) =>
        searchCondition.every((item) => {
          return o.name.toLowerCase().indexOf(item.value.toLowerCase()) >= 0;
        }),
      ),
    [searchCondition],
  );

  const onSelectChange = (value, select) => {
    setSelectedRowKeys(value);
  };

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: onSelectChange,
    type: 'radio',
  };
  const displayBody = () => {
    return (
      <React.Fragment>
        <SizeFittingTable
          rowKey='uuid'
          pagination={false}
          id='salesChannelSelectionTable'
          columns={columns({ getI18n })}
          className={css.salesChannelSelectionTable}
          dataSource={
            searchCondition.length ? filterSalesChannel : salesChannels
          }
          rowSelection={rowSelection}
          scroll={{ y: 470 }}
        />
      </React.Fragment>
    );
  };

  return (
    <Modal
      title={getI18n('general.selectSalesChannel')}
      visible={visible}
      width={900}
      onCancel={onCancel}>
      <div className={css.queryContainer}>
        <_Query
          onSearchChange={(e) => {
            const _search = cloneDeep(searchCondition);
            _search.push(e);
            setSearchCondition(_search);
          }}
          onTagClose={(e) => {
            let _searchConditions = cloneDeep(searchCondition);
            const { value } = e;

            _searchConditions = _searchConditions.filter((i) => {
              const { value: _value } = i;
              return _value !== value;
            });
            setSearchCondition(_searchConditions);
          }}
          data={{ search: searchCondition }}
        />
        {displayBody()}
      </div>
      <ModalFooter
        okText={getI18n('general.next')}
        cancelText={getI18n('general.cancel')}
        hideOkButton={!selectedRowKeys.length}
        okClassName={css.okBtn}
        onOk={onOkPress}
        onCancel={onCancel}
      />
    </Modal>
  );
};

export default SalesChannelSelection;
